export var PAGE_NAME = {
    ERROR: "error",
    VANTAGE_START: "start",
    VANTAGE_VIEW: "view",
    VANTAGE_ERROR: "error",
    VANTAGE_UNENROLLED: "unenrolled",
    VANTAGE_LOADER: "finding your account",
};
export var DEFAULTS = {
    SUB_FUNCTION: "",
    PAGE_FUNCTION: "",
    PAGE_NAME: "",
    SITE_IDENTIFIER: "vista",
    DEVICE: "<mobi/desk/tab>",
    PNL: "vista",
    CUSTOMER_TYPE: "consumer",
    PRODUCT: "generic",
    ERROR_MESSAGE: "",
    MESSAGE: "",
    PAGE_KIND: "",
    MESSAGE_TYPE: "",
};
export var PAGE_SUBFUNCTION = {
    ERROR: "error",
};
